const baseConfig = {
    S3_SERVICE_URL: undefined,
    REST_API_URL: undefined
};
export class Zauvu {
    constructor() {
        this._config = baseConfig;
    }
    configure(config) {
        this._config = config;
    }
    getConfig() {
        return this._config;
    }
}
export const zauvu = new Zauvu();
